import { Download, Gauge, Rocket, ShieldCheck, ArrowUpRight } from "lucide-react";
import { CONFIG, goToCheckout } from "../../config";
import { useI18n } from "../../i18n";

const STEPS = [
  { n: "01", icon: Download, t: "step1_t", d: "step1_d" },
  { n: "02", icon: Gauge, t: "step2_t", d: "step2_d" },
  { n: "03", icon: ShieldCheck, t: "step3_t", d: "step3_d" },
  { n: "04", icon: Rocket, t: "step4_t", d: "step4_d" },
];

export default function HowItWorks() {
  const { t, currency, fmtCcy } = useI18n();
  return (
    <section className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="chip">{t("how_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            {t("how_h1_a")} <span className="text-[color:var(--gold)]">{t("how_h1_b")}</span>
          </h2>
          <p className="text-[color:var(--ink-dim)] mt-4 leading-relaxed text-sm sm:text-base">{t("how_sub")}</p>
        </div>

        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {STEPS.map((s, i) => (
            <div key={s.n} className="panel p-5 sm:p-6 relative">
              <div className="font-mono text-[10px] sm:text-[11px] uppercase tracking-widest text-[color:var(--gold)]">
                {t("step_label")} · {s.n}
              </div>
              <div className="w-10 h-10 mt-4 rounded-xl grid place-items-center border border-[#23232a] bg-[rgba(231,180,59,.05)]">
                <s.icon className="w-4.5 h-4.5 text-[color:var(--gold)]" />
              </div>
              <div className="font-display font-bold text-base sm:text-[17px] mt-4">{t(s.t)}</div>
              <p className="text-[13px] sm:text-[13.5px] text-[color:var(--ink-dim)] mt-2 leading-relaxed">{t(s.d)}</p>
              {i < STEPS.length - 1 && <div className="hidden lg:block absolute right-[-10px] top-1/2 w-4 h-px bg-[color:var(--gold)]/40" />}
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 flex justify-center">
          <button onClick={() => goToCheckout(currency.code, currency.price)}
            className="btn-gold h-12 px-5 sm:px-6 rounded-full inline-flex items-center gap-2 text-sm font-display">
            {t("how_cta", { price: fmtCcy(currency.price) })} <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
